import * as Sentry from '@sentry/browser';

export const encodeBase64Url = (str: string) => btoa(encodeURIComponent(str));

export const decodeBase64Url = (str: string) => decodeURIComponent(atob(str));

export const tryDecodeBase64Url = (str: string) => {
  try {
    return decodeBase64Url(str);
  } catch (e) {
    console.error(e);
    Sentry.captureException(e);
    return str;
  }
};
